import { ChatChannel } from "@src/appV2/Chat/types";
import { Shift } from "@src/lib/interface";

export const ActionType = {
  SET_CHANNELS: "SET_CHANNELS",
  UPDATE_CHANNEL: "UPDATE_CHANNEL",
  SET_UPCOMING_SHIFTS: "SET_UPCOMING_SHIFTS",
};

export interface ChatStore {
  channels: ChatChannel[];
  upcomingShifts: { [key: string]: Shift };
}
